module.exports = __webpack_public_path__ + "static/media/team-kristen.f1c47aee.jpg";